import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppCodeComponent } from './appcode.component';
import { UserService, GroupAppCodePermission, UserAppCodePermission } from '../userData/user.service';
import { SharedModule } from '../../shared/shared.module';
import { BlocksModule } from '../../blocks/blocks.module';


@NgModule({
    imports: [SharedModule, CommonModule, BlocksModule],
    declarations: [ AppCodeComponent],
    providers: [UserService],
    exports: [AppCodeComponent]


})
export class AppCodesComponent { }
